import { DataTable } from '../../../../../components/UI/MDC/DataTable/DataTable';
import styles from '../../../ApplicationMaintenance.module.scss';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import { DeactivateExtensionType } from '../../../_api';
import ExtensionTypeRequest from '../../../../../Classes/ResponseModels/ApplicationManagement/ExtensionTypeRequest';
import { useState } from 'react';
import ApiErrors from '../../../components/NewApplication/ApiErrors';
import ExtensionTypeUpdate from './ExtensionTypeForms/ExtensionTypeUpdate';
//app : AppManagementModel
const ExtensionTypesTable = ({
	app,
	currentUser,
	requirementNumber,
	readOnly,
	reload,
}) => {
	const [apiErrors, setApiErrors] = useState([]);
	const headers = [
		{ Value: 'Actions', props: { sort: null, onSortChange: null } },
		{ Value: 'Description', props: { sort: null, onSortChange: null } },
		{ Value: 'Component ID', props: { sort: null, onSortChange: null } },
		{ Value: 'Extension Type', props: { sort: null, onSortChange: null } },
	];

	const ExtensionActions = ({ extension }) => {
		const handleDelete = extension => {
			const request = new ExtensionTypeRequest(
				app,
				currentUser,
				extension,
				requirementNumber
			);
			DeactivateExtensionType(request).then(response => {
				if (response.App.Errors.length === 0) {
					reload();
				} else {
					setApiErrors(response.App.Errors);
				}
			});
		};

		return (
			<div>
				<div className={styles.controlsContainer}>
					<Button
						startIcon={<MaterialIcon icon='delete' />}
						onClick={e => handleDelete(extension)}
						disabled={readOnly}
					>
						Delete
					</Button>
				</div>
				<ExtensionTypeUpdate
					extension={extension}
					app={app}
					currentUser={currentUser}
					requirementNumber={requirementNumber}
					readOnly={readOnly}
					reload={reload}
				/>
			</div>
		);
	};

	const rows = app.extensions?.map((ext, index) => {
		return {
			Cells: {
				Actions: {
					Value: <ExtensionActions extension={ext} />,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Description: {
					Value: ext.description,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Component ID': {
					Value: ext.f_Component_ID?.toString(),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Extension Type': {
					Value: ext.fiid,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: ext.fiid?.toString(),
		};
	});

	return (
		<div>
			<ApiErrors errors={apiErrors} />
			<DataTable rows={rows} headers={headers} />
		</div>
	);
};

export default ExtensionTypesTable;
